export default __webpack_public_path__ + "static/media/fly.2c400420.png";